import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import type { Binding } from "./types";

const mount = document.body.firstElementChild;
const endpoint = document.body.dataset.binding;
if (!(mount instanceof HTMLElement) || endpoint === undefined) throw new Error();
const binding = await fetch(endpoint).then(response => response.json()) as Binding;
createRoot(mount).render(<StrictMode><App binding={binding} /></StrictMode>);
